import { defineComponent, ref, watch } from "vue";
import * as KlipApi from "@/api/klip-api.proxy";
import {RouteRecordRaw} from 'vue-router';
import {useKlipApiProxy} from '@/plugins/proxy-client';

export class ProcessCounterData {
    counterType: KlipApi.ProcessCounter;
    counterRoute: RouteRecordRaw;
    counterText: string;
}

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlProcessCounter',
    props: {
        counter: {
            type: Object as () => ProcessCounterData,
            required: true
        }
    },
    setup(props) {
        const klipApiProxy = useKlipApiProxy();
        const processCounterLoading = ref<boolean>(true);
        const processCounter = ref<number>(0);
        const processCounterText = ref<string>();
        const processCounterRoute = ref<RouteRecordRaw>();
        const processCounterLoadingFailed = ref<boolean>(false);
        const processCounterCssClass = (counter: number) => {
            return counter > 0 ? 'alert' : 'success';
        };

        const processCounterIcon = (counter: number) => {
            return counter > 0 ? 'alert-circle' : 'check-circle';
        };

        const counterChanged = async (counter: ProcessCounterData) => {
            const counterResult = await klipApiProxy.processes_ProcessCounter(counter.counterType);
            processCounterText.value = counter.counterText;

            if (counterResult.isSuccessStatusCode && counterResult.result >= 0) {
                processCounter.value = counterResult.result;
                processCounterRoute.value = counter.counterRoute;
            } else {
                processCounterLoadingFailed.value = true;
            }

            processCounterLoading.value = false;
        };

        watch(() => props.counter, counterChanged, { immediate: true, deep: true });

        return {
            processCounterLoadingFailed,
            processCounterLoading,
            processCounterCssClass,
            processCounterText,
            processCounterIcon,
            processCounterRoute,
            processCounter
        };
    }
});
